import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getUserBizCode } from '@/utils/country'

const service = axios.create({
  baseURL: '',
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + store.getters.token
    }
    // 多国支持：管理端所有请求注入 bizCode 头（NG=pocketbuy / GH=pocketbuy_gh）。
    // 未登录（无用户上下文，如登录请求本身）取不到时不发送，由后端按登录场景处理。
    const bizCode = getUserBizCode()
    if (bizCode) {
      config.headers['bizCode'] = bizCode
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    // Blob / arraybuffer responses (e.g. CSV template download) are returned as-is
    const responseType = response.config && response.config.responseType
    if (responseType === 'blob' || responseType === 'arraybuffer') {
      const payload = response.data
      return responseType === 'blob' ? payload : payload
    }
    const res = response.data
    if (res.code !== 0) {
      const err = new Error(res.message || 'Request failed')
      err.code = res.code
      err.fieldErrors = Array.isArray(res.detail) ? res.detail : null
      Message({
        message: res.message || 'Request failed',
        type: 'error',
        duration: 3000
      })
      if (res.code === 'ERR-UM-003' || res.code === 'ERR-AUTH-003') {
        store.dispatch('logout')
        router.push('/login')
      }
      return Promise.reject(err)
    }
    return res
  },
  error => {
    if (error.response) {
      const status = error.response.status
      const data = error.response.data
      // Blob error bodies (e.g. validation errors on a blob request) need to be parsed
      let parsed = data
      if (data instanceof Blob) {
        // Synchronous fallback message; detailed parsing is handled by callers via parseBlobError
        parsed = null
      }
      if (status === 401) {
        const isLoginPage = router.currentRoute.path === '/login'
        if (isLoginPage) {
          const msg = (parsed && parsed.message) || 'Invalid credentials'
          Message({ message: msg, type: 'error', duration: 3000 })
        } else {
          store.dispatch('logout')
          router.push('/login')
          Message({ message: 'Session expired, please login again', type: 'warning' })
        }
      } else if (status === 403) {
        Message({ message: (parsed && parsed.message) || 'Permission denied', type: 'error', duration: 3000 })
      } else if (status === 413) {
        // 请求体超过服务器上限（nginx/网关层直接拒绝，响应体非标准 JSON，拿不到 message）
        Message({
          message: 'The file is too large. Please upload a file within the size limit (images ≤ 5MB, import files ≤ 10MB).',
          type: 'error',
          duration: 5000
        })
      } else {
        const msg = (parsed && parsed.message) || error.message || 'Network error'
        Message({ message: msg, type: 'error', duration: 3000 })
        if (parsed && Array.isArray(parsed.detail)) {
          error.fieldErrors = parsed.detail
        }
      }
    } else {
      if (!(error.config && error.config.skipNetworkErrorToast)) {
        Message({
          message: error.message || 'Network error',
          type: 'error',
          duration: 3000
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service
